import React from 'react';

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalTitle,
  ModalDescription
} from '@epoch-ui/components/Modal/modal';

interface SlackTipsModalProps extends React.ComponentPropsWithoutRef<typeof Modal> {}

export const SlackTipsModal: React.FC<SlackTipsModalProps> = ({ ...modalProps }) => {
  return (
    <Modal {...modalProps}>
      <ModalContent className="tw-max-w-2xl">
        <ModalHeader>
          <ModalTitle>Slack formatting tips</ModalTitle>
          <ModalDescription>
            Looking for more? See full formatting guidelines
            <a
              target="_blank"
              className="tw-ml-1 tw-text-blue-600 tw-underline hover:tw-text-blue-800"
              href="https://api.slack.com/reference/surfaces/formatting#line-breaks"
              rel="noopener noreferrer"
            >
              here
            </a>
          </ModalDescription>
        </ModalHeader>
        <div className="p-1 text-sm">
          <div>
            <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300 tw-py-2">
              <div>
                <p className="tw-m-0 tw-text-sm">*bold*</p>
              </div>
              <div className="tw-text-right">
                <strong>bold</strong>
              </div>
            </div>

            <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between  tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300 tw-py-2">
              <div>
                <p className="tw-m-0 tw-text-sm">_italic_</p>
              </div>
              <div className="tw-text-right">
                <em>italic</em>
              </div>
            </div>

            <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300 tw-py-2">
              <div>
                <p className="tw-m-0 tw-text-sm">{`> quoted`}</p>
              </div>
              <div className="tw-text-right">
                {/* <div className="tw-h-full tw-w-10 tw-border-l-2 tw-border-gray-300 tw-pl-2"></div> */}
                <p className="my-0 tw-border-0 tw-border-l-4 tw-border-solid tw-border-gray-300 tw-pl-2 tw-text-gray-500">
                  quoted
                </p>
              </div>
            </div>

            <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300 tw-py-2">
              <div>
                <p className="tw-m-0 tw-text-sm">~strikethrough~</p>
              </div>
              <div className="tw-text-right">
                <del>strikethrough</del>
              </div>
            </div>

            <div className="tw-mb-2 tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-b-2 tw-border-solid tw-border-gray-300 tw-py-2">
              <div>
                <p className="tw-m-0 tw-text-sm">{`<https://epochapp.com|Epoch>`}</p>
              </div>
              <div className="tw-text-right">
                <a
                  href="https://epochapp.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:text-blue-800 underline"
                >
                  Epoch
                </a>
              </div>
            </div>

            <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-border-gray-100 tw-py-1">
              <div>
                <p className="tw-m-0 tw-text-sm">:heart: :rocket: :mask:</p>
              </div>
              <div className="tw-text-right">❤️ 🚀 😷</div>
            </div>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};
